<template>
  <div class="generic" :class="{ '-is-last': isLast }" ref="generic">
    <a :href="item.permalink">{{ item.post_title | ellipsize(90) }}</a>
    <p>{{ item.post_excerpt | ellipsize(90) }}</p>
  </div>
</template>

<script>
export default {
  props: ["item", "isLast"],
  filters: {
    ellipsize(value, cutoff) {
      value = value || "";

      return value.length > cutoff ? value.slice(0, cutoff) + "..." : value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../css/abstracts/colors";

.generic {
  width: 100%;
  margin-bottom: 2.125rem;

  &.-is-last {
    margin-bottom: 0;
  }

  a,
  p {
    margin-bottom: 0.375rem;
  }

  a {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 700;
  }
}
</style>
